(function () {
  'use strict';

  function initDeeplaySwatches(root) {
    if (!root || root.dataset.dfswReady === 'true') return;
    root.dataset.dfswReady = 'true';

    var maxSelections = Math.max(1, parseInt(root.dataset.maxSelections || '5', 10));
    var minSelections = Math.max(1, parseInt(root.dataset.minSelections || '1', 10));
    var selected = [];
    var toastTimer = null;

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-dfsw-swatch]'));
    var slots = Array.prototype.slice.call(root.querySelectorAll('[data-dfsw-selected-slot]'));
    var countLabel = root.querySelector('[data-dfsw-count]');
    var selectedHidden = root.querySelector('[data-dfsw-selected-hidden]');
    var countHidden = root.querySelector('[data-dfsw-count-hidden]');
    var bodyHidden = root.querySelector('[data-dfsw-body-hidden]');
    var form = root.querySelector('.dfsw-form');
    var submit = root.querySelector('[data-dfsw-submit]');
    var consent = root.querySelector('[data-dfsw-consent]');
    var startButton = root.querySelector('[data-dfsw-start]');
    var categories = root.querySelector('[data-dfsw-categories]');
    var toast = root.querySelector('[data-dfsw-toast]');
    var toastTitle = root.querySelector('[data-dfsw-toast-title]');
    var toastMessage = root.querySelector('[data-dfsw-toast-message]');

    function cardData(card) {
      var img = card.querySelector('img');
      return {
        id: card.dataset.swatchId || '',
        name: card.dataset.swatchName || '',
        category: card.dataset.swatchCategory || '',
        image: img ? (img.currentSrc || img.src || '') : ''
      };
    }

    function findSelectedIndex(id) {
      for (var i = 0; i < selected.length; i += 1) {
        if (selected[i].id === id) return i;
      }
      return -1;
    }

    function showToast(title, message) {
      if (!toast) return;
      window.clearTimeout(toastTimer);
      if (toastTitle) toastTitle.textContent = title || root.dataset.popupTitle || 'Maximum samples selected';
      if (toastMessage) toastMessage.textContent = message || root.dataset.popupMessage || 'You have reached the sample limit.';
      toast.classList.add('is-visible');
      toast.setAttribute('aria-hidden', 'false');
      toastTimer = window.setTimeout(function () {
        toast.classList.remove('is-visible');
        toast.setAttribute('aria-hidden', 'true');
      }, Math.max(1500, parseInt(root.dataset.popupDuration || '3500', 10)));
    }

    function buildSelectedSummary() {
      return selected.map(function (item, index) {
        return (index + 1) + '. ' + item.name + (item.category ? ' — ' + item.category : '');
      }).join('\n');
    }

    function buildContactBody() {
      var parts = ['DEEPLAY FREE FABRIC SAMPLE REQUEST', ''];
      if (form) {
        var get = function (selector) {
          var field = form.querySelector(selector);
          return field ? String(field.value || '').trim() : '';
        };
        parts.push('Customer: ' + [get('[name="contact[First name]"]'), get('[name="contact[Last name]"]')].filter(Boolean).join(' '));
        parts.push('Email: ' + get('[name="contact[email]"]'));
        parts.push('Phone: ' + get('[name="contact[phone]"]'));
        parts.push('');
        parts.push('Delivery address:');
        parts.push(get('[name="contact[Address line 1]"]'));
        if (get('[name="contact[Address line 2]"]')) parts.push(get('[name="contact[Address line 2]"]'));
        parts.push(get('[name="contact[Town / City]"]'));
        if (get('[name="contact[County]"]')) parts.push(get('[name="contact[County]"]'));
        parts.push(get('[name="contact[Postcode]"]'));
      }
      parts.push('');
      parts.push('Selected fabrics:');
      parts.push(buildSelectedSummary());
      parts.push('');
      parts.push('Total selected: ' + selected.length);
      return parts.filter(function (part, index, all) {
        return part !== '' || all[index - 1] !== '';
      }).join('\n');
    }

    function render() {
      cards.forEach(function (card) {
        var isSelected = findSelectedIndex(card.dataset.swatchId || '') !== -1;
        var isLocked = selected.length >= maxSelections && !isSelected;
        card.classList.toggle('is-selected', isSelected);
        card.classList.toggle('is-locked', isLocked);
        card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      slots.forEach(function (slot, index) {
        var item = selected[index];
        var imageWrap = slot.querySelector('.dfsw-selected-slot__image-wrap');
        var name = slot.querySelector('.dfsw-selected-slot__name');
        slot.classList.toggle('has-swatch', !!item);
        slot.dataset.swatchId = item ? item.id : '';
        if (imageWrap) {
          imageWrap.innerHTML = item && item.image
            ? '<img src="' + item.image.replace(/"/g, '&quot;') + '" alt="">'
            : '';
        }
        if (name) name.textContent = item ? item.name : '';
        slot.setAttribute('aria-label', item ? 'Remove ' + item.name : 'Empty selected swatch slot ' + (index + 1));
      });

      if (countLabel) countLabel.textContent = selected.length + ' / ' + maxSelections + ' selected';
      if (selectedHidden) selectedHidden.value = buildSelectedSummary();
      if (countHidden) countHidden.value = String(selected.length);
      if (bodyHidden) bodyHidden.value = buildContactBody();

      if (submit) {
        var selectionReady = selected.length >= minSelections && selected.length <= maxSelections;
        var consentReady = consent ? consent.checked : true;
        submit.disabled = !(selectionReady && consentReady);
      }
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        var data = cardData(card);
        var index = findSelectedIndex(data.id);

        if (index !== -1) {
          selected.splice(index, 1);
          render();
          return;
        }

        if (selected.length >= maxSelections) {
          showToast(root.dataset.popupTitle, root.dataset.popupMessage);
          return;
        }

        selected.push(data);
        render();
      });
    });

    slots.forEach(function (slot) {
      slot.addEventListener('click', function () {
        var id = slot.dataset.swatchId || '';
        if (!id) return;
        var index = findSelectedIndex(id);
        if (index !== -1) {
          selected.splice(index, 1);
          render();
        }
      });
    });

    if (consent) consent.addEventListener('change', render);

    if (startButton && categories) {
      startButton.addEventListener('click', function () {
        categories.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    if (form) {
      form.addEventListener('input', function () {
        if (bodyHidden) bodyHidden.value = buildContactBody();
      });

      form.addEventListener('submit', function (event) {
        if (selected.length < minSelections) {
          event.preventDefault();
          showToast('Choose your samples', 'Please select at least ' + minSelections + ' fabric sample' + (minSelections === 1 ? '' : 's') + ' before submitting.');
          return;
        }

        if (selected.length > maxSelections) {
          event.preventDefault();
          showToast(root.dataset.popupTitle, root.dataset.popupMessage);
          return;
        }

        if (selectedHidden) selectedHidden.value = buildSelectedSummary();
        if (countHidden) countHidden.value = String(selected.length);
        if (bodyHidden) bodyHidden.value = buildContactBody();
      });
    }

    Array.prototype.slice.call(root.querySelectorAll('[data-dfsw-category]')).forEach(function (category) {
      var track = category.querySelector('[data-dfsw-track]');
      var previous = category.querySelector('[data-dfsw-prev]');
      var next = category.querySelector('[data-dfsw-next]');
      var progress = category.querySelector('[data-dfsw-progress]');
      if (!track) return;

      function updateCarousel() {
        var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        var ratio = maxScroll > 0 ? track.scrollLeft / maxScroll : 1;
        if (progress) progress.style.width = Math.max(12, Math.min(100, ratio * 100)) + '%';
        if (previous) previous.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= maxScroll - 2;
      }

      function scrollTrack(direction) {
        var amount = Math.max(220, Math.round(track.clientWidth * 0.78));
        track.scrollBy({ left: amount * direction, behavior: 'smooth' });
      }

      if (previous) previous.addEventListener('click', function () { scrollTrack(-1); });
      if (next) next.addEventListener('click', function () { scrollTrack(1); });
      track.addEventListener('scroll', updateCarousel, { passive: true });
      window.addEventListener('resize', updateCarousel);
      window.requestAnimationFrame(updateCarousel);
    });

    render();
  }

  function initAll(scope) {
    var container = scope || document;
    Array.prototype.slice.call(container.querySelectorAll('[data-deeplay-swatches]')).forEach(initDeeplaySwatches);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();